import { render, staticRenderFns } from "./chunai_bh.vue?vue&type=template&id=279341c0&scoped=true"
import script from "./chunai_bh.vue?vue&type=script&lang=js"
export * from "./chunai_bh.vue?vue&type=script&lang=js"
import style0 from "./chunai_bh.vue?vue&type=style&index=0&id=279341c0&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279341c0",
  null
  
)

export default component.exports